import React, { useEffect, useState } from "react";
import { MdAdd, MdDelete, MdEdit, MdConfirmationNumber } from "react-icons/md";
import CountUp from "react-countup";
import { ExclamationCircleFilled } from "@ant-design/icons";

import api from "../../../services/api";
import { Container, Cards, Card, Table, Title, ViewInput } from "./styles";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  Input,
  DatePicker,
  Switch,
  Spin,
  Pagination,
} from "antd";
import IntlCurrencyInput from "react-intl-currency-input";
import { addDays, format } from "date-fns";
import dayjs, { locale } from "dayjs";
import Loading from "../../../components/Loading";
import { getValue } from "../../../services/functions";
import { Message } from "../../../GlobalStyles";

const currencyConfig = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

const { confirm } = Modal;

const Coupon = () => {
  const [coupons, setCoupons] = useState([]);
  const [couponsTotal, setCouponsTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [filter, setFilter] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [name, setName] = useState("");
  const [value, setValue] = useState("");
  const [minValue, setMinValue] = useState("");
  const [usageLimit, setUsageLimit] = useState("");
  const [isSingleUse, setIsSingleUse] = useState(false);
  const [active, setActive] = useState(true);
  const [code, setCode] = useState("");
  const [type, setType] = useState("");
  const [id, setId] = useState("");
  const [expirationDate, setExpirationDate] = useState(addDays(new Date(), 30));
  const [isOpen, setIsOpen] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);

  useEffect(() => {
    loadCoupons();
    window.scrollTo(0, 0);
  }, [page, filterSearch]);

  async function loadCoupons() {
    setIsLoading(true);
    await api
      .get(`/coupons?page=${page}${filter ? `&filter=${filter}` : ""}`)
      .then((response) => {
        setCoupons(response.data.coupons);
        setCouponsTotal(response.data.couponsTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function createCoupon() {
    setIsLoadingModal(true);
    if (!name || !value || !type) {
      toast.warning("Preencha os campos obrigatórios");
      setError(true);
    } else {
      await api
        .post(`/coupon`, {
          name: name,
          code: code,
          value: value,
          type: type,
          minValue: minValue,
          active: active,
          usageLimit: usageLimit,
          expirationDate: expirationDate,
          isSingleUse: isSingleUse,
        })
        .then((response) => {
          toast.success("Cupom de Desconto criado com sucesso");
          setIsOpen(false);
          loadCoupons();
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        });
    }
    setIsLoadingModal(false);
  }

  async function editCoupon() {
    setIsLoadingModal(true);
    if (!id || !name || !value || !type) {
      toast.warning("Preencha os campos obrigatórios");
      setError(true);
    } else {
      await api
        .put(`/coupon/${id}`, {
          name: name,
          code: code,
          value: value,
          type: type,
          minValue: minValue,
          active: active,
          usageLimit: usageLimit,
          expirationDate: expirationDate,
          isSingleUse: isSingleUse,
        })
        .then((response) => {
          toast.success("Cupom de Desconto editado com sucesso");
          setIsOpen(false);
          loadCoupons();
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        });
    }
    setIsLoadingModal(false);
  }

  async function deleteCoupon(coupon) {
    await api
      .delete(`/coupon/${coupon.id}`)
      .then((response) => {
        toast.success("Cupom de Desconto deletado com sucesso");
        loadCoupons();
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <h1>Cupons de Desconto</h1>
      {isLoading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={couponsTotal} />
          </Card>
          <div className="filter">
            <ViewInput style={{ width: 300 }}>
              <p>Pesquisar</p>
              <Input.Search
                value={filter}
                onChange={(text) => {
                  setFilter(text.target.value);
                }}
                placeholder="pesquisar"
                onSearch={(text) => {
                  setFilterSearch(text);
                  if (page) {
                    setPage(0);
                  } else {
                    loadCoupons(0, filterSearch);
                  }
                }}
                allowClear
                onClear={() => {
                  setFilterSearch("");
                  if (page) {
                    setPage(0);
                  }
                  setFilter("");
                }}
                enterButton
              />
            </ViewInput>
            <Button
              type="primary"
              style={{
                marginTop: 17,
                marginLeft: 50,
                borderRadius: 50,
              }}
              onClick={() => {
                setId("");
                setCode("");
                setName("");
                setUsageLimit("");
                setValue("");
                setType("");
                setMinValue("");
                setActive(true);
                setIsSingleUse(false);
                setExpirationDate(addDays(new Date(), 30));
                setError(false);
                setIsOpen(true);
              }}
            >
              Novo Cupom
            </Button>
          </div>
          {coupons.length ? (
            <>
              <Table>
                <thead>
                  <tr>
                    <td style={{ textAlign: "left" }}>Nome</td>
                    <td>Código</td>
                    <td>Ativo</td>
                    <td>Uso Unico</td>
                    <td>Valor Minimo</td>
                    <td>Desconto</td>
                    <td>Limite de Uso</td>
                    <td>Expira</td>
                    <td style={{ width: 80 }}></td>
                  </tr>
                </thead>
                <tbody>
                  {coupons.map((coupon) => (
                    <tr key={coupon.id}>
                      <td style={{ textAlign: "left" }}>{coupon.name}</td>
                      <td>{coupon.code.toUpperCase()}</td>
                      <td style={{ textTransform: "capitalize" }}>
                        {coupon.active ? "Sim" : "Não"}
                      </td>
                      <td style={{ textTransform: "capitalize" }}>
                        {coupon.isSingleUse ? "Sim" : "Não"}
                      </td>
                      <td style={{ textTransform: "capitalize" }}>
                        {getValue(coupon.minValue)}
                      </td>
                      <td style={{ textTransform: "capitalize" }}>
                        {coupon.type == "FIXED"
                          ? getValue(coupon.value)
                          : `${coupon.value}%`}
                      </td>
                      <td style={{ textTransform: "capitalize" }}>
                        {coupon.usageLimit || "Sem limites"}
                      </td>
                      <td>
                        {format(new Date(coupon.expirationDate), "dd/MM/yyyy")}
                      </td>
                      <td
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <MdEdit
                          onClick={() => {
                            setId(coupon.id);
                            setName(coupon.name);
                            setCode(coupon.code);
                            setValue(coupon.value);
                            setType(coupon.type);
                            setActive(coupon.active);
                            setIsSingleUse(coupon.isSingleUse);
                            setUsageLimit(coupon.usageLimit);
                            setMinValue(coupon.minValue);
                            setExpirationDate(coupon.expirationDate);
                            setError(false);
                            setIsOpen(true);
                          }}
                          style={{ cursor: "pointer", marginLeft: 5 }}
                          size={22}
                          color={"#001B22"}
                        />
                        <MdDelete
                          onClick={() => {
                            confirm({
                              okText: "Confirmar",
                              title: "Deseja excluir a Cupom de Desconto?",
                              icon: <ExclamationCircleFilled />,
                              content: `Após essa ação, a cobrança recorrente ${coupon.name} será excluido`,
                              onOk() {
                                deleteCoupon(coupon);
                              },
                              onCancel() {},
                              cancelText: "Cancelar",
                            });
                          }}
                          style={{ cursor: "pointer", marginLeft: 5 }}
                          size={22}
                          color={"#001B22"}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          ) : (
            <Message>
              <p>Nenhum cupom encontrado</p>
            </Message>
          )}
        </>
      )}

      <Pagination
        style={{
          margin: "25px 0",
          alignSelf: "center",
        }}
        defaultCurrent={page + 1}
        pageSize={30}
        onChange={(page) => {
          setPage(page - 1);
        }}
        total={couponsTotal}
      />
      <Modal
        title="Cupom de Desconto"
        width={500}
        confirmLoading={isLoadingModal}
        open={isOpen}
        okText={id ? "EDITAR CUPOM" : "CADASTRAR CUPOM"}
        cancelText="FECHAR"
        onOk={() => {
          if (id) {
            editCoupon();
          } else {
            createCoupon();
          }
        }}
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginBottom: 25,
          }}
        >
          <ViewInput>
            <p>Nome*</p>
            <Input
              status={error && !name && "error"}
              placeholder="nome"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Código*</p>
            <Input
              status={error && !code && "error"}
              placeholder="codigo"
              value={code}
              onChange={(event) => setCode(event.target.value)}
            />
          </ViewInput>

          <ViewInput>
            <p>Desconto Fixo ou Percentual?*</p>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                style={{
                  width: "49%",
                  borderColor: error && !type ? "#ff4d4f" : "",
                }}
                type={type == "FIXED" && "primary"}
                onClick={() => {
                  setType("FIXED");
                  setValue("");
                }}
              >
                Fixo
              </Button>
              <Button
                style={{
                  width: "49%",
                  borderColor: error && !type ? "#ff4d4f" : "",
                }}
                type={type == "PERCENTAGE" && "primary"}
                onClick={() => {
                  setType("PERCENTAGE");
                  setValue("");
                }}
              >
                Percentual
              </Button>
            </div>
          </ViewInput>
          {type == "PERCENTAGE" ? (
            <ViewInput>
              <p>Desconto em Percentual*</p>
              <Input
                status={error && !value && "error"}
                placeholder="desconto em percentual"
                value={value}
                onChange={(event) =>
                  setValue(parseInt(event.target.value.replace(/[^0-9]/g, "")))
                }
              />
            </ViewInput>
          ) : (
            <ViewInput>
              <p>Valor de Desconto*</p>
              <IntlCurrencyInput
                style={{
                  width: "100%",
                  backgroundColor: "#FFF",
                  borderWidth: 0,
                  color: "#001B22",
                  padding: "4px 12px",
                  fontSize: 14,
                  borderWidth: 1,
                  borderColor: error && !value ? "#ff4d4f" : "#ccc",
                  borderStyle: "solid",
                  borderRadius: 2,
                  fontWeight: "400",
                  paddingLeft: 12,
                }}
                currency="BRL"
                config={currencyConfig}
                value={value}
                onChange={(event, value) => setValue(value)}
              />
            </ViewInput>
          )}
          <ViewInput>
            <p>Limite de Uso*</p>
            <Input
              placeholder="parcelas"
              value={usageLimit}
              onChange={(event) =>
                setUsageLimit(
                  parseInt(event.target.value.replace(/[^0-9]/g, ""))
                )
              }
            />
          </ViewInput>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <ViewInput
              style={{
                width: "49%",
              }}
            >
              <p>Ativo?*</p>
              <div style={{ width: "100%", display: "flex" }}>
                <Switch
                  type="primary"
                  value={active}
                  style={{ justifySelf: "flex-start" }}
                  onChange={(text, type) => {
                    setActive(!active);
                  }}
                />
              </div>
            </ViewInput>
            <ViewInput
              style={{
                width: "49%",
              }}
            >
              <p>Uso Unico?*</p>
              <div style={{ width: "100%", display: "flex" }}>
                <Switch
                  type="primary"
                  value={isSingleUse}
                  style={{ justifySelf: "flex-start" }}
                  onChange={(text, type) => {
                    setIsSingleUse(!isSingleUse);
                  }}
                />
              </div>
            </ViewInput>
          </div>
          <ViewInput>
            <p>Valor Minimo*</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 0,
                color: "#001B22",
                padding: "4px 12px",
                fontSize: 14,
                borderWidth: 1,
                borderStyle: "solid",
                borderRadius: 2,
                fontWeight: "400",
                paddingLeft: 12,
              }}
              currency="BRL"
              config={currencyConfig}
              value={minValue}
              onChange={(event, value) => setMinValue(value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Data de expiração</p>
            <DatePicker
              placeholder={"data de expiração"}
              format={"DD/MM/YYYY"}
              locale={locale}
              minDate={dayjs(addDays(new Date(), 1))}
              value={expirationDate ? dayjs(expirationDate) : ""}
              style={{
                minWidth: "100%",
                height: 32,
                display: "flex",
                alignItems: "center",
                borderRadius: 2,
              }}
              onChange={(date) => setExpirationDate(date)}
            />
          </ViewInput>
        </div>
      </Modal>
    </Container>
  );
};

export default Coupon;
